import styles from './OverlayHomeStretch.module.css';
import Overlay from './Overlay.js';
import CallToActionButton from './CallToActionButton.js';
import Background from './Background.js';
import Profile from './Profile.js';
import Banner from './Banner.js';
import PlayIcon from './PlayIcon.js';
import ArticleTitle from './ArticleTitle.js';
import ArticleTitleDashVariant from './ArticleTitleDashVariant.js';
import Theme from './Theme.js';

const OverlayHomeStretch = () => (
  <Theme>
    <Overlay>
      <Background>
        <div className={styles.overlayHomeStretchWrapper}>
          <Profile />
          <Banner />
          <ArticleTitle />
          <ArticleTitleDashVariant />
          <CallToActionButton icon={<PlayIcon />} />
        </div>
      </Background>
    </Overlay>
  </Theme>
);

OverlayHomeStretch.displayName = 'OverlayHomeStretch';

export default OverlayHomeStretch;
